module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/food-app-6-de35a9dd8c623d311984fe0c8c3aebb8.png";